import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from "@angular/router";
import { clearLocalStorage } from 'src/services/environment';

@Injectable()
export class TokenInterceptorInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // const token = this.authService.getToken()
    // if (token) {
    //   let tokenToReplace = token.replace(/^"|"$/g, '');

    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: "Bearer " + tokenToReplace
    //     }
    //   });
    // }

    request = request.clone({
        withCredentials: true,
      });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Se la risposta è 401, reindirizza alla pagina "Access Denied"
          // todo da decommentare dopo i test
          clearLocalStorage();
          this.router.navigate(['/login']);
        }

        // else if (error.status === 502) {
        //   clearLocalStorage();
        //   this.router.navigate(['/page-not-found']);
        // }
        // Rilancia l'errore per gestioni ulteriori se necessario
        return throwError(error);
      })
    );
  }


}
